import { render, staticRenderFns } from "./SuccessSnackbar.vue?vue&type=template&id=622afff2&"
import script from "./SuccessSnackbar.vue?vue&type=script&lang=js&"
export * from "./SuccessSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports